import classnames from 'classnames';
import React, { cloneElement, useCallback } from 'react';
import { TabBarRootNodeProps } from './iTabs'

const TabBarRootNode: React.FC<TabBarRootNodeProps> = (props) => {
    const {
        clsPrefix = '',
        onKeyDown = () => {},
        extraContent = null,
        tabBarPosition = 'top',
        children = null,
        dir: direction,
        tabBarClassName,
        tabBarStyle,
        type,
        saveRef = () => {},
        domkey,
        ...restProps
    } = props;
    const topOrBottom = (tabBarPosition === 'top' || tabBarPosition === 'bottom');
    const extraContentStyle = (extraContent && (extraContent as React.ReactElement).props) ? (extraContent as React.ReactElement).props.style : {};

    const getExtraContentStyle = useCallback(() => {
        if (direction === 'rtl') {
            return topOrBottom ? {float: 'left'} : {};
        }
        return topOrBottom ? {float: 'right'} : {};
    }, [tabBarPosition, direction]);

    const cls = classnames(`${clsPrefix}-bar ${clsPrefix}-${type}-bar ${clsPrefix}-bar-${tabBarPosition}`, {
        [`${tabBarClassName}`]: tabBarClassName
    });

    let newChildren = children;
    if (extraContent) {
        newChildren = [
            cloneElement((extraContent as React.ReactElement), {
                key: 'extra',
                style: {
                    ...getExtraContentStyle(),
                    ...extraContentStyle,
                },
            }),
            cloneElement((children as React.ReactElement), {key: 'content'}),
        ];
        newChildren = topOrBottom ? newChildren : (newChildren as any[]).reverse();
    }

    return (
        <div
            role="tablist"
            className={cls}
            tabIndex={0}
            ref={saveRef?.('root') as React.LegacyRef<HTMLDivElement>}
            onKeyDown={onKeyDown}
            style={tabBarStyle}
            // @ts-ignore
            domkey={domkey}
            {...Object.keys(restProps).reduce((prev, key) => {
                if (key.slice(0, 5) === 'aria-' || key.slice(0, 5) === 'data-' || key === 'role') (prev as any)[key] = (props as any)[key];
                return prev;
            }, {})}
        >
            {newChildren}
        </div>
    );
};

export default TabBarRootNode;
